<!-- <div class="light-blue-bg pt-4 my-0 intro-banner">
  <div class="container">
    <div class="row d-flex align-items-center">
      <div class="col-md-5 col-12 mb-1 mt-5 my-md-0 text-md-left text-center">
        <h1 id="titre">{{'Sensibilisation en Réalité Augmentée' | translate}}</h1>
        <p class="mt-3">{{'L’utilisateur devient acteur au sein de scénarios réalistes qui mettent en pratique des processus complexes et des situations à risques' | translate}}</p>
        <div class="mb-3 mb-md-0 mt-4">
          <a class="btn btn-immersive btn-rounded green-button w-75 mb-3" (click)="scrollToAnchor('app-download')" title="Test on mobile"><i class="fas fa-play mr-2"></i>{{'Tester sur mobile' | translate}}</a>
          <button class="btn btn-immersive btn-rounded w-75" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Informations Abonnement AR')}" title="Contact us"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
        </div>
      </div>
      <div class="col-md-7 col-12 mt-md-0 mt-3">
        <picture>
            <source srcset="assets/senar-woman-ar3.webp" type="image/webp">
            <source srcset="assets/senar-woman-ar3.png" type="image/jpg">
            <img src="assets/senar-woman-ar3.png" class="float-right first-block" alt="A worker using an AR simulator on her tablet" title="Augmented reality awareness" loading="lazy">
        </picture>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="light-blue my-0 intro-banner">
  <div class="container">
    <div class="row d-flex align-items-start align-items-md-center justify-content-center justify-content-md-start min-h-544">
      <div class="text-md-left text-center w-50 pl-0 pl-md-3 mt-5 mt-md-0">
        <h1 id="titre">{{'Sensibilisation en Réalité Augmentée' | translate}}</h1>
        <p class="mt-3">{{'L’utilisateur devient acteur au sein de scénarios réalistes qui mettent en pratique des processus complexes et des situations à risques' | translate}}</p>
        <div class="mb-3 mb-md-0 mt-4">
          <a class="btn btn-immersive btn-rounded green-button px-5 mb-3 d-block w-55 mx-auto mx-md-0" (click)="scrollToAnchor('app-download')" title="Test on mobile"><i class="fas fa-play mr-2"></i>{{'Tester sur mobile' | translate}}</a>
          <button class="btn btn-immersive btn-rounded px-5 d-block w-55 mx-auto mx-md-0" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Informations Abonnement AR')}" title="Contact us"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="light-blue my-0 intro-banner2">
  <div class="container">
    <div class="row d-flex align-items-start align-items-md-center justify-content-center justify-content-md-start min-h-544">
      <div class="text-md-left text-center w-75 pl-0 pl-md-3 mt-5 mt-md-0">
        <h1 id="titre">{{'Sensibilisation en Réalité Augmentée' | translate}}</h1>
        <p class="mt-3">{{'L’utilisateur devient acteur au sein de scénarios réalistes qui mettent en pratique des processus complexes et des situations à risques' | translate}}</p>
        <div class="mb-3 mb-md-0 mt-4 d-flex align-items-center justify-content-center justify-content-md-start flex-md-row flex-column">
          <a class="btn btn-immersive btn-rounded green-button px-5 d-inline-block mr-md-3 mr-0 mb-md-0 mb-3" (click)="scrollToAnchor('app-download')" title="Test on mobile"><i class="fas fa-play mr-2"></i>{{'Tester sur mobile' | translate}}</a>
          <button class="btn btn-immersive btn-rounded px-5 d-block" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Informations Abonnement AR')}" title="Contact us"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<hr class="my-0 py-0">

<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mx-auto" style="max-width: 1400px;width:75%;" role="document">
    <div class="modal-content">
      <i data-dismiss="modal" class="close fas fa-times-circle"></i>
      <div class="modal-body">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" [src]="videoSrc" id="video"  allowscriptaccess="always" allow="autoplay" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="py-4 text-center d-flex align-items-center justify-content-center flex-wrap custom-gap">
    <ng-container *ngFor="let logo of certifications">
      <img *ngIf="logo.isSVG" class="logo-container" src="{{logo.src}}.svg" alt="{{logo.alt}} logo" title="{{logo.title}}" [attr.width]="logo.width" loading="lazy"/>
    </ng-container>
  </div>

<hr class="my-0 py-0">

<div class="container my-5">
    <div class="row d-flex justify-content-center align-items-top mb-4">
        <div class="col-12 col-md-6 pr-4 mb-4">
          <div class="block-pricing sub-middle">
            <div class="block-header">{{'Abonnement AR' | translate}}</div>
            <div class="block-content">
              <div class="block-prices py-4">
                <div class="px-0">
                  <div class="prices-loading" *ngIf="loading"></div>
                  <div class="prices-value animate__animated animate__fadeIn text-center" *ngIf="!loading">
                    <div class="price-workshop">
                      <span class="mr-1">{{basketService.currencySymbol}}</span>
                      <span>
                        <app-currency [currency]="basketService.currentCurrency" [currencyvalue]="3000"></app-currency>
                      </span>
                      <span class="ht"> {{'HT' | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center mb-5">
                <picture>
                    <source srcset="assets/senar-ar-offer.webp" type="image/webp">
                    <source srcset="assets/senar-ar-offer.jpg" type="image/jpg">
                    <img src="assets/senar-ar-offer.jpg" class="w-100" alt="AR subscription" title="Senar - Our AR offer" loading="lazy">
                </picture>
              </div>
              <div class="text-center">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : translate.instant('Informations Abonnement AR')}" title="Contact us"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 pl-4 mb-4">
          <h2 class="title">{{'Notre offre en réalité augmentée pour votre formation santé sécurité' | translate}}</h2>
          <div class="d-flex mt-4 mb-3">
              <i class="fas fa-check-circle mr-1 custom-circle"></i>
              <p class="mb-0 text-justify">{{'Accès aux ateliers en réalité augmentée' | translate}}</p>
          </div>
          <div class="d-flex mb-3">
              <i class="fas fa-check-circle mr-1 custom-circle"></i>
              <p class="mb-0 text-justify">{{'Passages illimités sur mobile pendant 1 an' | translate}}</p>
          </div>
          <div class="d-flex mb-3">
              <i class="fas fa-check-circle mr-1 custom-circle"></i>
              <p class="mb-0 text-justify">{{'Rapports anonymes horodatés' | translate}}</p>
          </div>
          <div class="d-flex mb-3">
              <i class="fas fa-check-circle mr-1 custom-circle"></i>
              <p class="mb-0 text-justify">{{'Pour mobile et tablette' | translate}}</p>
          </div>
          <div class="d-flex">
              <i class="fas fa-check-circle mr-1 custom-circle"></i>
              <p class="mb-0 text-justify">{{'Support, maintenance et mises à jour régulières' | translate}}</p>
          </div>
        </div>
    </div>
</div>

<hr class="my-0 py-0">

<div class="grey-bg my-0">
    <div class="py-5">
        <div class="container text-center">
            <span class="title">{{'Les thèmes disponibles' | translate}}</span>
        </div>
        <div class="container mt-5">
            <div class="row all-cards text-center">
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x orange"></i>
                          <i class="fas fa-fire-extinguisher fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Sécurité incendie' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal orange my-0">1 {{'simulateur' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                      <span class="fa-stack fa-lg mb-3">
                        <i class="fas fa-square fa-stack-2x purple"></i>
                        <app-svg-icon class="topic-icon" [src]="'assets/svg/person-falling-solid.svg'" [size]="'21.333px'"></app-svg-icon>
                      </span>
                      <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Prévention des chutes' | translate}}</p>
                      <div class="simus text-center"><p class=" font-weight-normal purple my-0">5 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x green"></i>
                          <i class="fas fa-link fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Élingage' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal green my-0">3 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x red"></i>
                          <i class="fas fa-lock fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Consignation' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal red my-0">{{'Simulateurs personnalisés' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x pink"></i>
                          <i class="fas fa-heartbeat fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'RCP et premiers secours' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal pink my-0">4 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                      <span class="fa-stack fa-lg mb-3">
                        <i class="fas fa-square fa-stack-2x grey"></i>
                        <i class="fas fa-car fa-stack-1x fa-inverse"></i>
                      </span>
                      <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Engins motorisés' | translate}}</p>
                      <div class="simus text-center"><p class=" font-weight-normal grey my-0">2 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x yellow"></i>
                          <i class="fas fa-bolt fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Formations en électricité' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal dark-yellow my-0">4 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 mb-4">
                    <div class="full-w-h blocks-topics p-4 position-relative">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-square fa-stack-2x dark-blue"></i>
                          <i class="fas fa-stethoscope fa-stack-1x fa-inverse"></i>
                        </span>
                        <p class="mt-1 mb-2 font-weight-bold text-uppercase">{{'Soins de santé' | translate}}</p>
                        <div class="simus text-center"><p class=" font-weight-normal dark-blue my-0">3 {{'simulateurs' | translate}}</p></div>
                    </div>
                </div>
            </div>
            <div class="mt-4 text-center">
              <a class="btn btn-immersive btn-rounded px-5" (click)="scrollToAnchor('app-download')" title="Test on mobile"><i class="fas fa-play mr-2"></i>{{'Tester sur mobile' | translate}}</a>
            </div>
        </div>
    </div>
</div>

<hr class="my-0 py-0">

<div class="container py-5">
  <div class="text-center mb-5 mt-0">
      <h2 class="title">{{'Qui est Senar ?' | translate}}</h2>
  </div>
  <div class="row d-flex text-justify align-items-top pb-1 mb-md-4 mb-1">
      <div class="col-12 col-md-6 pr-md-4 pl-md-0 px-3 pt-2 mb-md-0 mb-4">
                <p>{{'SENAR a vu le jour avec pour mission d’' | translate}}<span class="blue-text">{{'accroître la sécurité et la performance sur le lieu de travail' | translate}}</span>. {{'Pour cela, l’entreprise a développé la première plateforme de' | translate}} <span class="blue-text">{{'formation en réalité augmentée' | translate}}</span> {{'permettant de déployer rapidement des simulateurs AR sur mobile' | translate}}.</p>
                <p>{{'Les collaborateurs peuvent désormais accéder, directement sur leur téléphone ou sur une tablette, à une' | translate}} <span class="blue-text">{{'formation immersive' | translate}}</span> {{'simulant des situations grandeur nature, trop dangereuses, trop coûteuses ou impossibles à reproduire dans le monde réel' | translate}}</p>
        </div>
        <div class="col-12 col-md-6 p-0 m-0 video-banner" id="image-video1" (click)="video()" data-toggle="modal" data-target="#exampleModalCenter">
          <span class="fa-stack fa-lg youtube" id="test">
            <i class="fas fa-circle fa-stack-2x light-grey"></i>
            <i class="fas fa-play fa-stack-1x fa-inverse"></i>
          </span>
        </div>
  </div>
</div>

<hr class="my-0 py-0">

<div class="container py-5">
  <div class="text-center mb-5 mt-0">
      <h2 class="title">{{'Les avantages de la Réalité Augmentée' | translate}}</h2>
  </div>
  <div class="row d-flex text-justify align-items-top">
      <div class="col-12 col-md-6 mb-md-0 mb-4 pr-md-4 pl-md-0 px-3">
          <picture>
              <source srcset="assets/senar-avantages-realite-augmentee.webp" type="image/webp">
              <source srcset="assets/senar-avantages-realite-augmentee.jpg" type="image/jpg">
              <img src="assets/senar-avantages-realite-augmentee.jpg" alt="Visual of a CPR and first aid training in AR" title="CPR and first aid training in AR" class="border-radius shadow w-100" loading="lazy"/>
          </picture>
      </div>
      <div class="col-12 col-md-6 pl-md-4 pr-md-0 px-3">
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="blue-text">{{'Immersion' | translate}}</span> : {{'Les simulateurs en réalité augmentée recréent des environnements réels en 3D à taille réelle' | translate}}
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="blue-text">{{'Mémorisation' | translate}}</span> : {{'Les simulateurs AR activent à la fois la mémoire spatiale et la mémoire musculaire de l’utilisateur, ce qui augmente son attention' | translate}}
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="blue-text">{{'Motivation' | translate}}</span> : {{'Les utilisateurs sont acteurs de leur formation, et non plus spectateurs. Ils sont immergés dans un environnement impressionnant et ludique' | translate}}
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="blue-text">{{'Multijoueur' | translate}}</span> : {{'1 tablette/1 téléphone = une session. Vous pouvez faire passer autant de personnes que vous le souhaitez en même temps' | translate}}
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="blue-text">{{'Feedback en temps réel' | translate}}</span> : {{'le formateur présent lors de la session peut vérifier, en passant voir les utilisateurs, et leur donner un feedback sur leurs actions immédiates' | translate}}
            </p>
        </div>
      </div>
  </div>
</div>


<hr class="my-0 py-0">

<!-- <div class="light-blue my-0" id="app-download">
  <div class="py-5">
      <div class="container text-center">
          <span class="title">{{'Testez gratuitement sur votre téléphone' | translate}}</span>
          <p class="my-4">{{'4 simulateurs en réalité augmentée sont disponibles. Il vous suffit de lancer l’application et de cliquer sur “ACCÈS INVITÉ”' | translate}}</p>
      </div>
      <div class="container mt-4 mb-0">
          <div class="row all-cards text-center">
              <div class="col-md-6 col-sm-12 mb-4">
                  <div class="full-w-h blocks p-5">
                    <a href="{{IosUrl}}" target="_blank" rel="noopener nofollow" title="IOS app download"><img class="badges" src="assets/logos-senar/{{'App-store-badge-fr' | translate}}.svg" loading="lazy" alt="Badge to download Senar application on IOS" title="Download application for IOS"/></a>
                  </div>
              </div>
              <div class="col-md-6 col-sm-12 mb-4">
                  <div class="full-w-h blocks p-5">
                    <a href="{{AndroidUrl}}" target="_blank" rel="noopener nofollow" title="Android app download"><img class="badges" src="assets/logos-senar/{{'googleplay-badge-fr' | translate}}.svg" loading="lazy" alt="Badge to download Senar application on Android" title="Download application for Android"/></a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->

<div class="light-blue py-3 my-0" id="app-download">
  <div class="py-5">
      <div class="container text-center">
          <span class="title">{{'Testez gratuitement sur votre téléphone' | translate}}</span>
          <p class="my-4">{{'4 simulateurs en réalité augmentée sont disponibles. Il vous suffit de lancer l’application et de cliquer sur “ACCÈS INVITÉ”' | translate}}</p>
      </div>
      <div class="container mb-2">
          <div class="d-flex justify-content-center align-items-center flex-md-row flex-column">
              <a class="mr-md-3 mr-0 mb-4 mb-md-0" href="{{IosUrl}}" target="_blank" rel="noopener nofollow" title="IOS app download"><img class="badges" src="assets/logos-senar/{{'App-store-badge-fr' | translate}}.svg" loading="lazy" alt="Badge to download Senar application on IOS" title="Download application for IOS"/></a>
              <a class="ml-md-3 ml-0" href="{{AndroidUrl}}" target="_blank" rel="noopener nofollow" title="Android app download"><img class="badges" src="assets/logos-senar/{{'googleplay-badge-fr' | translate}}.svg" loading="lazy" alt="Badge to download Senar application on Android" title="Download application for Android"/></a>
          </div>
      </div>
  </div>
</div>
